import { createSelector } from 'reselect';
import { getConnector } from '../services/PatientFacingClient';
import { RootState } from '../store';

export const conversationIdSelector = (
  state: RootState,
  props: { conversationId?: string; id?: string }
) => state.conversation.id || (props && (props.conversationId || props.id));
export const conversationSelector = createSelector(
  getConnector,
  conversationIdSelector,
  (connector: any, id: string) => connector.client.conversations.getById(id)
);
export const conversationMemberIdsSelector = (state: RootState) => state.conversation.members;
export const conversationMembersSelector = createSelector(
  getConnector,
  conversationMemberIdsSelector,
  (connector: any, memberIds: string[]) => connector.client.users.getMultiById(memberIds || [])
);
